import * as moment from 'moment-timezone';
import { AModel } from '../../../../api/abstracts/model.abstract';

export class PrequalApprovalModel extends AModel {
    public fillables: any = {
        ApprovalDate: 'ApprovalDate',
        VoucherExpDate: 'VoucherExpDate',
    }
    public defaults: any = {
    }
    constructor (args) {
        super(args)
        this.init(args, this);
        const today = moment();
        const voucherExpr = moment().add(1, 'M');
        const pstToday = today.tz('America/Los_Angeles');
        const expiry = voucherExpr.tz('America/Los_Angeles');
        this.set('ApprovalDate', pstToday.format('MM/DD/YYYY'));
        this.set('VoucherExpDate', expiry.format('MM/DD/YYYY'));
    }
}

export class UserProfileModel extends AModel {
    public fillables: any = {
        // Backend payload structure //
        Email: 'Email',
        PhoneNumber: 'PhoneNumber',
        DateOfBirth: 'DateOfBirth',
        SSN: 'SSN',
        Address: 'Address',
        City: 'City',
        State: 'State',
        MonthlyIncome: 'MonthlyIncome',
        LengthOfAddressYear: 'LengthOfAddressYear',
        LengthOfAddressMonth: 'LengthOfAddressMonth',
        LengthOfJobYear: 'LengthOfJobYear',
        LengthOfJobMonth: 'LengthOfJobMonth',
        PreferredDownPayment: 'PreferredDownPayment',
        PreferredMonthlyPayment: 'PreferredMonthlyPayment',
        PreferredLoanAmount: 'PreferredLoanAmount',
        HowDidYouHearAboutUs: 'HowDidYouHearAboutUs',
        AppointmentTime: 'AppointmentTime',
        IsCosignerCohabitant: 'IsCosignerCohabitant',
        RentMortgage: 'RentMortgage',
        IncomeType: 'IncomeType',
        FirstName: 'FirstName',
        LastName: 'LastName',
        SSN4: 'SSN4',
        ZipCode: 'ZipCode',
        IsCoBuyer: 'IsCoBuyer',
        PrivacyPolicyConsent: 'PrivacyPolicyConsent',
        MarketingConsent: 'MarketingConsent',

        // This will transform the original UI payload into backend payload structure //
        email: 'Email',
        phoneNumber: 'PhoneNumber',
        DOB: 'DateOfBirth',
        ssn: 'SSN',
        address: 'Address',
        city: 'City',
        state: 'State',
        zipCode: 'ZipCode',
        monthlyIncome: 'MonthlyIncome',
        lengthOfAddressYear: 'LengthOfAddressYear',
        lengthOfAddressMonth: 'LengthOfAddressMonth',
        lengthOfJobYear: 'LengthOfJobYear',
        lengthOfJobMonth: 'LengthOfJobMonth',
        preferredDownPayment: 'PreferredDownPayment',
        preferredMonthlyPayment: 'PreferredMonthlyPayment',
        howDidYouHearAboutUs: 'HowDidYouHearAboutUs',
        preferredLoanAmount: 'PreferredLoanAmount',
        appointmentTime: 'AppointmentTime',
        isCosignerCohabitant: 'IsCosignerCohabitant',
        rentMortgage: 'RentMortgage',
        incomeType: 'IncomeType',
        firstName: 'FirstName',
        lastName: 'LastName',
        ssn4: 'SSN4',
        isCoBuyer: 'IsCoBuyer',
        privacyPolicyConsent: 'PrivacyPolicyConsent',
        marketingConsent: 'MarketingConsent'
    }
    public defaults: any = {
        incomeType: 'Salary',
        isCoBuyer: false,
        IsCoBuyer: false,
        LengthOfJobMonth: 0,
        LengthOfAddressMonth: 0,
        MarketingConsent: false,
        PrivacyPolicyConsent: false,
        IsCosignerCohabitant: false,
        isCosignerCohabitant: false,
    }
    constructor (args) {
        super(args)
        this.init(args, this);
    }

    public _lengthOfJobYearHandler (value) {
        if (!value) return 0;
        var values = value.toString().split('.');
        if (values.length > 1) {
            this.set('LengthOfJobMonth', this.computeMonth(values[1]));
        }
        return parseInt(values[0]);
    }
    public _lengthOfAddressYearHandler (value) {
        if (!value) return 0;
        var values = value.toString().split('.');
        if (values.length > 1) {
            this.set('LengthOfAddressMonth', this.computeMonth(values[1]));
        }
        return parseInt(values[0]);
    }

    private computeMonth (value: any): number {
        if (isNaN(value)) return 0;
        var month = parseFloat(value);
        month = 12 * (month * 0.1);
        return parseInt(month.toString(), 10);
    }

}
export class UserTrackingInfoModel extends AModel {
    public fillables: any = {
        // Backend payload structure //
        AcceptTermsAndConditions: 'AcceptTermsAndConditions',
        CampaignId: 'CampaignId',
        DeviceType: 'DeviceType',
        GCLID: 'GCLID',
        IpAddress: 'IpAddress',
        IpLocation: 'IpLocation',
        Keyword: 'Keyword',
        LandingUrl: 'LandingUrl',
        MediaCode: 'MediaCode',
        WebLeadAdgroup: 'WebLeadAdgroup',
        WebLeadCampaign: 'WebLeadCampaign',
        WebLeadMedium: 'WebLeadMedium',
        VisitedPage: 'VisitedPage',
        WebLeadCreative: 'WebLeadCreative',
        WebLeadMatchType: 'WebLeadMatchType',
        WebLeadSource: 'WebLeadSource',
        WidgetType: 'WidgetType',

        // This will transform the original UI payload into backend payload structure //
        device: 'DeviceType',
        widgetType: 'WidgetType',
        campaign: 'CampaignId',
        adGroup: 'WebLeadAdgroup',
        medium: 'WebLeadMedium',
        keywords: 'Keyword',
        source: 'WebLeadSource',
        advertisement: 'WebLeadCreative',
        matchType: 'WebLeadMatchType',
        gclid: 'GCLID',
        leadURL: 'LandingUrl',
        mediaCode: 'MediaCode',
        
    }
    public defaults: any = {
        VisitedPage: '',
        AcceptTermsAndConditions: true,
        WidgetType: 'WFS-Direct Long Form'
    }
    constructor (args) {
        super(args)
        this.init(args, this);
    }
}

export class VehicleItemModel extends AModel {
    public fillables: any = {
        BPDealerInfo: 'BPDealerInfo',
        BasicInfo: 'BasicInfo',
        BookComparisonValue: 'BookComparisonValue',
        BuyProgramWholesale: 'BuyProgramWholesale',
        CityMPG: 'CityMPG',
        Coords: 'Coords',
        DCInventoryID: 'DCInventoryID',
        DealerInfo: 'DealerInfo',
        Description: 'Description',
        DirectUrl: 'DirectUrl',
        DiscountPercent: 'DiscountPercent',
        Distance: 'Distance',
        DriveTrain: 'DriveTrain',
        EligibleForListing: 'EligibleForListing',
        Engine: 'Engine',
        Equipment: 'Equipment',
        EquipmentList: 'EquipmentList',
        FuelType: 'FuelType',
        HighwayMPG: 'HighwayMPG',
        InventoryId: 'InventoryId',
        InventoryMinFrontGross: 'InventoryMinFrontGross',
        InventoryStatusId: 'InventoryStatusId',
        MainExternalDocumentId: 'MainExternalDocumentId',
        MainThumbnailUrl: 'MainThumbnailUrl',
        MaxDiscount: 'MaxDiscount',
        PaymentInfo: 'PaymentInfo',
        PhotoList: 'PhotoList',
        Photos: 'Photos',
        SessionId: 'SessionId',
        ShowOnWebsites: 'ShowOnWebsites',
        TotalCost: 'TotalCost',
        Transmission: 'Transmission',
        VehicleClass: 'VehicleClass',
        VehicleId: 'VehicleId',
        VehicleInvoicePrice: 'VehicleInvoicePrice',
        WestlakeClassCode: 'WestlakeClassCode',
    }
    public defaults: any = {
    }
    constructor (args) {
        super(args)
        this.init(args, this);
    }
}

export class ClassicCarVehicleModel extends AModel {
    public fillables: any = {
        vehicleYear: 'VehicleYear',
        vehicleMake: 'VehicleMake',
        vehiclePrice: 'VehiclePrice',
        vehicleModel: 'VehicleModel',
    }
    public defaults: any = {
    }
    get isValid (): boolean {
        return this.get('vehicleYear') ||
            this.get('vehicleMake') ||
            this.get('vehiclePrice') ||
            this.get('vehicleModel');
    }
    constructor (args) {
        super(args)
        this.init(args, this);
    }
    _vehiclePriceHandler(value) {
        if (!value) return value;
        return parseFloat(value.replace(/\D/img, ''));
    }
}

export class PrequalModel extends AModel {
    public fillables: any = {
        DealId: 'DealId',
        IsDemo: 'IsDemo',
        Source: 'Source',
        SessionId: 'SessionId',
        CoBuyer: UserProfileModel,
        InventoryId: 'InventoryId',
        VehicleItem: VehicleItemModel,
        UserProfile: UserProfileModel,
        PreQualApproval: PrequalApprovalModel,
        UserTrackingInfo: UserTrackingInfoModel,
        ClassicCarVehicle: ClassicCarVehicleModel,        

        dealId: 'DealId',
        isClassic: 'IsClassic',
        captchaToken: 'captchaToken',
    }
    public defaults: any = {
        IsDemo: 0,
        DealId: 0,
        SessionId: '',
        InventoryId: '',
        IsClassic: false,
        UserProfile: null,
        Source: 'Loan Center',
        PreQualApproval: null,
        UserTrackingInfo: null,
    }
    constructor (args) {
        super(args);
        if (args.COBuyerDetails) {
            this.set('CoBuyer', args.COBuyerDetails);
        }
        if (args.VehicleDetails) {
            this.set('VehicleItem', args.VehicleDetails);
        }
        this.set('ClassicCarVehicle', args);
        this.set('UserProfile', args);
        this.set('UserTrackingInfo', args);
        this.set('PreQualApproval', args);
        this.init(args, this);

        // We don't want to send an empty object on a payload //
        if (this.get('ClassicCarVehicle') && !this.get('ClassicCarVehicle').isValid) {
            this.set('ClassicCarVehicle', null);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auto-loans/models/prequal.model.ts